import { useSelector } from 'react-redux'
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useParams,
  useRouteMatch
} from 'react-router-dom'
import { Layout } from 'src/components/Layout'
import { useAppSelector } from 'src/redux/hooks'
import { RootState } from 'src/redux/root'
import {
  isLoading,
  selectAllSettingsConfirmed
} from 'src/redux/slices/analysis/selectors'
import { TabsConfig, WorkflowTopLevelProps } from 'src/types/general'

import BarChartIcon from '@material-ui/icons/BarChart'
import HomeWorkIcon from '@material-ui/icons/HomeWork'
import PublishIcon from '@material-ui/icons/Publish'
import SettingsIcon from '@material-ui/icons/Settings'

import AdoptionPage from './pages/AdoptionPage'
import GraphsPage from './pages/GraphsPage'
import SettingsPage from './pages/SettingsPage'
import UploadPage from './pages/UploadPage'

///// Component
const AnalysisWorkflow: React.FC<React.PropsWithChildren<WorkflowTopLevelProps>> = ({
  children,
  tabValue,
}) => {
  const loading = useSelector(isLoading)
  const error = useAppSelector((state: RootState) => state.analysis.error)
  const hasData = useAppSelector((state: RootState) => state.analysis.data !== null)
  const allSettingsConfirmed = useSelector(selectAllSettingsConfirmed)
  const { path } = useRouteMatch()

  const tabsConfig: TabsConfig = {
    tabs: {
      upload: {
        title: 'Upload',
        description: 'Upload files for visualization and analysis',
        label: 'Upload',
        disabled: false,
        icon: <PublishIcon />,
        component: <UploadPage />,
      },
      settings: {
        title: 'Settings',
        description: 'Configure settings for visualization and analysis',
        label: 'Settings',
        disabled: !hasData,
        icon: <SettingsIcon />,
        component: <SettingsPage />,
      },
      'technology-pathways': {
        title: 'Technology Pathways',
        description: 'Compare Data Across Scenarios',
        label: 'Technology Pathways',
        disabled: !allSettingsConfirmed || !hasData,
        icon: <BarChartIcon />,
        component: <GraphsPage />,
      },
      adoption: {
        title: 'Adoption',
        description: 'Simulate technology adoption pathways',
        label: 'Adoption',
        disabled: !allSettingsConfirmed || !hasData,
        icon: <HomeWorkIcon />,
        component: <AdoptionPage />,
      },
    },
    defaultTab: 'upload',
    root: {
      title: 'Analysis',
      description: 'Analyze UBEM Results',
      component: <div>Help info coming</div>,
      redirect: true,
    },
    otherRoutes: {
      someOtherRoute: {
        component: <div>hello there</div>,
      },
    },
    // root: "analysis",
  }
  return (
    <Layout tabsConfig={tabsConfig} loading={loading}>
      {children}
    </Layout>
  )
}

export default AnalysisWorkflow
